import { useContext } from "react";
import { FavoriteContext } from "../context/FavoriteContext";

export default function useFavorites(): number[]|null {
    const [favorites] = useContext(FavoriteContext) ?? [null];

    return favorites;
}